<div class="confirm-cont column-base div-center">
  <i-tabler
    name="alert-circle"
    class="icon-20"
    style="height: 88px; width: 88px; color: #fdc560 !important"
  ></i-tabler>

  <h2 style="text-align: center" class="">
    ¿Estás seguro de eliminar este documento?
  </h2>

  <span class="warn">Esta acción no se puede deshacer.</span>
  <div class="div-center row-base" style="width: 100%; gap: 30px">
    <button
      (click)="onSave()"
      class="buttonPrimary row-base div-center div-vertical-center white-spinner"
      style="
        gap: 4px;
        min-width: 95px;
        box-shadow: none !important;
        min-height: 36px;
      "
      [style.cursor]="loading ? 'not-allowed' : 'pointer'"
    >
      <mat-spinner *ngIf="loading" [diameter]="16"></mat-spinner>

      <span *ngIf="!loading">Si, eliminar</span>
    </button>
    <button
      mat-flat-button
      style="
        border: 1px solid #e95a1a;
        border-radius: 4px;
        width: 95px;
        color: #e95a1a;
      "
      (click)="onCancel()"
      class="m-l-8"
    >
      Cancelar
    </button>
  </div>
</div>
